import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectBuilding } from '@store/actionSlices/building'
import { selectProjectConfig } from '@store/actionSlices/projectConfig'
import { selectFilteredUnit } from '@store/actionSlices/unitFilter'
import { ExtendedUnitFilterOptions } from '@store/types'

import getFilteredBuildingData from '@utilities/filter-building'

const useExplorerLevels = () => {
  const building = useSelector(selectBuilding)
  const unitFilter = useSelector(selectFilteredUnit)
  const { showPrice, statusLabels } = useSelector(selectProjectConfig)
  const isFilterApplied = unitFilter.apply

  const { listLevels, matchingLevelsById } = useMemo(() => {
    const getLevels = (filter: ExtendedUnitFilterOptions) =>
      getFilteredBuildingData(
        building,
        filter,
        showPrice,
        building.blockOrders.length,
        statusLabels?.available
      )

    const blockLevels = getLevels({ ...unitFilter, apply: false })
    const matchingLevels = isFilterApplied
      ? getLevels({ ...unitFilter, anyLevel: true })
      : blockLevels
    const matchingById = new Map(
      matchingLevels.map((level) => [level.level, level])
    )

    return {
      listLevels: blockLevels.map(
        (level) => matchingById.get(level.level) ?? { ...level, data: [] }
      ),
      matchingLevelsById: matchingById,
    }
  }, [building, unitFilter, isFilterApplied, showPrice, statusLabels])

  return { listLevels, matchingLevelsById, isFilterApplied }
}

export default useExplorerLevels
